import { __awaiter, __generator } from "tslib";
import { SPRest } from "../rest.js";
import { Web } from "../webs/types.js";
import "./web.js";
import { SharePointQueryable } from "../sharepointqueryable.js";
export { App, AppCatalog, } from "./types.js";
SPRest.prototype.getTenantAppCatalogWeb = function () {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2 /*return*/, this.childConfigHook(function (_a) {
                    var options = _a.options, runtime = _a.runtime;
                    return __awaiter(_this, void 0, void 0, function () {
                        var data;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, SharePointQueryable("/", "_api/SP_TenantSettings_Current").configure(options).setRuntime(runtime)()];
                                case 1:
                                    data = _b.sent();
                                    if (!(data === null || data === void 0 ? void 0 : data.CorporateCatalogUrl)) {
                                        throw new Error("Failed to get tenant corporate app catalog, its not configured on the tenant.");
                                    }
                                    return [2 /*return*/, Web(data.CorporateCatalogUrl).configure(options).setRuntime(runtime)];
                            }
                        });
                    });
                })];
        });
    });
};
//# sourceMappingURL=index.js.map